import { render, staticRenderFns } from "./CytologyTextPreview.vue?vue&type=template&id=1c91c686&scoped=true&"
import script from "./CytologyTextPreview.vue?vue&type=script&lang=js&"
export * from "./CytologyTextPreview.vue?vue&type=script&lang=js&"
import style0 from "./CytologyTextPreview.vue?vue&type=style&index=0&id=1c91c686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c91c686",
  null
  
)

export default component.exports